import styled from 'shared/utils/styled';

type CheckboxIconAccessories = Partial<{
  checked: boolean;
}>;

export const CheckboxIconWrapper = styled('span', {
  shouldForwardProp: (prop) => prop !== 'checked',
})<CheckboxIconAccessories>(({ theme, checked = false }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: 20,
  height: 20,
  background: '#F0F3F7',
  border: '1px solid rgba(34, 64, 96, .2)',
  ...(checked && {
    background: theme.palette.success.main,
    borderColor: theme.palette.success.main,
  }),
}));
